import './HorizontalCard.scss';

function HorizontalCard({ titulo, texto, children }) {
    return (
        <div className='horizontal-card'>
            <div className='card-wrapper'>
                <h3>{titulo}</h3>
                <p>{texto}</p>

                {/* Renderiza HTML "filho", se houver */}
                { children }
            </div>
        </div>
    )
}

export default HorizontalCard;